import React, {Component} from "react";
import {Map, MapMarker} from "react-kakao-maps-sdk";

class AddressSearchKakaoMap extends Component{

    render(){
        const rootStore = this.props.rootStore;

        return(
            <div className={"map"}>
            {
                //(rootStore.addressSearchStore.getKakaoMapLat)?
                (rootStore.addressSearchStore.getKakaoMapLat.length > 0 && rootStore.addressSearchStore.getKakaoMapLng > 0) ?
                    <Map
                        center={{ lat: rootStore.addressSearchStore.getKakaoMapLat, lng: rootStore.addressSearchStore.getKakaoMapLng }}
                        style={{ width: "100%", height: "316px" }}
                    >
                        <MapMarker position={{ lat: rootStore.addressSearchStore.getKakaoMapLat, lng: rootStore.addressSearchStore.getKakaoMapLng }}>
                        </MapMarker>
                    </Map>
                    :null
            }
            </div>
        )
    }
}

export default AddressSearchKakaoMap;